import FaqMain from '@/components/Faq/index'
const Faq = () => {
    const element = (<FaqMain />)
    return element
}
export default Faq